import React from 'react';
import { Button, Modal, Typography } from '@attentive-platform/stem-ui';

import { UnlinkModalStyles as S } from './styles';

const EFFECTS = [
  'The company drops back to free-form and the enterprise-conversion gate blocks again.',
  'New takeoffs stop showing scope cards until a record is linked or a legacy SOP is configured.',
  'The submission itself is untouched — it stays in the scope console and can be re-linked.'
];

const UnlinkModal = ({ show, onClose, onConfirm, submitting }) => (
  <Modal
    show={show}
    onClose={onClose}
    heading={<span className='pl-4'>Unlink scope record</span>}
    content={
      <S.ContentWrap>
        <S.Heading>Unlink this scope record?</S.Heading>
        <Typography variant='body2' color='#4D4D4D' sx={{ lineHeight: 1.6 }}>
          The company goes back to having no scope of record. That means:
        </Typography>
        <S.Effects>
          {EFFECTS.map(text => (
            <S.BulletRow key={text}>
              <S.BulletDot />
              <Typography variant='body3' color='#4D4D4D' sx={{ lineHeight: 1.55 }}>
                {text}
              </Typography>
            </S.BulletRow>
          ))}
        </S.Effects>
        <S.NoteBox>
          <Typography variant='body4' color='#4D4D4D' sx={{ lineHeight: 1.55 }}>
            Takeoffs already submitted keep the scope snapshot pinned to them — unlinking changes nothing about work
            already in flight.
          </Typography>
        </S.NoteBox>
        <S.Actions>
          <Button variant='outlined' color='primary' size='medium' onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant='contained'
            color='error'
            size='medium'
            loading={submitting}
            onClick={onConfirm}>
            Unlink scope record
          </Button>
        </S.Actions>
      </S.ContentWrap>
    }
  />
);

export default UnlinkModal;
